import { addDays, addYears, subDays, subYears } from "date-fns";

import { useI18n } from "vue-i18n";

const SHORTCUTS = {
    TODAY: "today",
    YESTERDAY: "yesterday",
    NEXT_7_DAYS: "next_7_days",
    LAST_7_DAYS: "last_7_days",
    NEXT_30_DAYS: "next_30_days",
    LAST_30_DAYS: "last_30_days",
    NEXT_YEAR: "next_year",
    LAST_YEAR: "last_year",
};

export function useDatepicker() {
    const { t } = useI18n();

    const customShortcuts = [
        {
            key: SHORTCUTS.TODAY,
            label: t("components.inputs.datepicker.shortcuts.today"),
            onClick: () => {
                const date = new Date();

                return {
                    start: date,
                    end: date,
                };
            },
        },
        {
            key: SHORTCUTS.YESTERDAY,
            label: t("components.inputs.datepicker.shortcuts.yesterday"),
            onClick: () => {
                const date = new Date();
                date.setDate(date.getDate() - 1);

                return {
                    start: date,
                    end: date,
                };
            },
        },
        {
            key: SHORTCUTS.NEXT_7_DAYS,
            label: t("components.inputs.datepicker.shortcuts.next_7_days"),
            onClick: () => {
                const date = new Date();

                return {
                    start: date,
                    end: addDays(date, 7),
                };
            },
        },
        {
            key: SHORTCUTS.LAST_7_DAYS,
            label: t("components.inputs.datepicker.shortcuts.last_7_days"),
            onClick: () => {
                const date = new Date();

                return {
                    start: subDays(date, 7),
                    end: date,
                };
            },
        },
        {
            key: SHORTCUTS.NEXT_30_DAYS,
            label: t("components.inputs.datepicker.shortcuts.next_30_days"),
            onClick: () => {
                const date = new Date();

                return {
                    start: date,
                    end: addDays(date, 30),
                };
            },
        },
        {
            key: SHORTCUTS.LAST_30_DAYS,
            label: t("components.inputs.datepicker.shortcuts.last_30_days"),
            onClick: () => {
                const date = new Date();

                return {
                    start: subDays(date, 30),
                    end: date,
                };
            },
        },
        {
            key: SHORTCUTS.NEXT_YEAR,
            label: t("components.inputs.datepicker.shortcuts.next_year"),
            onClick: () => {
                const date = new Date();

                return {
                    start: date,
                    end: addYears(date, 1),
                };
            },
        },
        {
            key: SHORTCUTS.LAST_YEAR,
            label: t("components.inputs.datepicker.shortcuts.last_year"),
            onClick: () => {
                const date = new Date();

                return {
                    start: subYears(date, 1),
                    end: date,
                };
            },
        },
    ];

    return {
        customShortcuts,
    };
}
